import React from "react";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import CoreBenefitsSection from "@/components/CoreBenefitsSection";
import WhoWeServeSection from "@/components/WhoWeServeSection";
import ProductCategoriesSection from "@/components/ProductCategoriesSection";
import WhyChooseUsSection from "@/components/WhyChooseUsSection";
import BrandsSection from "@/components/BrandsSection";
import SocialProofSection from "@/components/SocialProofSection";
import InventorySection from "@/components/InventorySection";
import LocationsSection from "@/components/LocationsSection";
import FAQSection from "@/components/FAQSection";
import QuoteFormSection from "@/components/QuoteFormSection";
import FinalCTASection from "@/components/FinalCTASection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <CoreBenefitsSection />
        <WhoWeServeSection />
        <ProductCategoriesSection />
        <WhyChooseUsSection />
        <BrandsSection />
        <SocialProofSection />
        <InventorySection />
        <LocationsSection />
        <FAQSection />
        <QuoteFormSection />
        <FinalCTASection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;
